import { alpha, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";

import Context from "../../context";

export default function MaintenanceIconMobile() {
	const { theme } = useContext(Context);
	return (
		<Stack
			position={"absolute"}
			sx={{
				width: "100%",
				height: "100%",
				backgroundColor: alpha("#919EAB", 0.15),
				borderRadius: 1,
				left: 0
			}}
			gap={0.5}
		>
			<Stack flexDirection={"row"} alignItems={"center"} sx={{ mt: 6, ml: 2 }} gap={0.5}>
				<Iconify icon={"mdi:tools"} color={theme?.colors.primary} width={12} />
				<Typography fontSize={10} variant={"subtitle1"} color={theme?.colors.primary}>
					{"Mantenimiento"}
				</Typography>
			</Stack>
		</Stack>
	);
}
